<!--suppress HtmlUnknownBooleanAttribute, XmlInvalidId, AngularUndefinedBinding -->
<form id="package-info" class="section general-info my-3">
  <div class="info">
    <div *ngIf="message" class="text-danger mt-3 mb-5" translate style="font-size:18pt">{{ message }}</div>
    <h6>
      <span translate>My Package</span>
      {{ this.lang == 'ar' ? paylinkSubscription.subscriptionNameAr : paylinkSubscription.subscriptionName }}
      <span style="font-size: 8pt" class="text-info" *ngIf="paylinkSubscription.subscriptionType == 'marketing'" translate>(Promotion Package)</span>
      <span style="font-size: 8pt" [ngClass]="daysRemaining < 15? 'text-danger' : 'text-success'" *ngIf="merchantPackage && merchantPackage.endDate">
        تنتهي في {{ getDateString(merchantPackage.endDate) | date :'d/M/y' }}
        <span *ngIf="daysRemaining > 0">(بعد {{ daysRemaining }} يوم)</span>
        <span *ngIf="daysRemaining == 0">(إنتهت)</span>
      </span>
      <span *ngIf="(isMerchant || isManager) && !isSelecting && !myBusiness.isPsp && !isPaying && (paylinkSubscription.yearlyFees > 0 || paylinkSubscription.monthlyFees > 0) && paylinkSubscription.subscriptionType != 'marketing'" class="f-8 text-primary">
        (
        <a (click)="renewPackage()" class="text-secondary" translate href="javascript:void(0)"> {{ 'renew package' }}</a>
        <a href="https://www.youtube.com/watch?v=XnkXKF4tldk" target="_blank" class="mx-2">
          <svg width="15" height="15" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
            <g id="Group">
              <path id="Path" fill="#06209f" stroke="none"
                    d="M 683.015686 117.331543 C 526.902344 -38.973694 273.638733 -39.129089 117.331566 116.982361 C -38.973663 273.097717 -39.130989 526.363159 116.984306 682.670349 C 273.095764 838.975586 526.36322 839.130981 682.670349 683.017639 C 838.973694 526.906128 839.130981 273.636841 683.015686 117.331543 Z M 455.850311 653.819031 C 455.850311 659.991028 450.848602 664.988892 444.68042 664.988892 L 355.321472 664.988892 C 349.15332 664.988892 344.151642 659.991028 344.151642 653.819031 L 344.151642 322.097748 C 344.151642 315.925751 349.15332 310.927887 355.321472 310.927887 L 444.68042 310.927887 C 450.848602 310.927887 455.850311 315.923828 455.850311 322.097748 L 455.850311 653.819031 Z M 400.000977 264.571594 C 364.281158 264.571594 335.218811 235.513062 335.218811 199.791382 C 335.218811 164.073486 364.279266 135.009216 400.000977 135.009216 C 435.722656 135.009216 464.783112 164.071594 464.783112 199.791382 C 464.783112 235.513062 435.718811 264.571594 400.000977 264.571594 Z"/>
            </g>
            <g id="g1"/>
          </svg>
        </a>
        )
      </span>
      <span *ngIf="!paylinkSubscription.isSpecialPackage && (isMerchant || isManager) && !isSelecting && !myBusiness.isPsp" class="f-8 text-primary">
        (
        <a (click)="changePackage()" class="text-primary" translate href="javascript:void(0)"> {{ isPaying ? 'back' : 'Change package or use coupon' }}</a>
        <a href="https://www.youtube.com/watch?v=oTm6Z-G3QuU" target="_blank" class="mx-2">
                    <svg width="15" height="15" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
                      <g id="Group">
                        <path id="Path" fill="#06209f" stroke="none"
                              d="M 683.015686 117.331543 C 526.902344 -38.973694 273.638733 -39.129089 117.331566 116.982361 C -38.973663 273.097717 -39.130989 526.363159 116.984306 682.670349 C 273.095764 838.975586 526.36322 839.130981 682.670349 683.017639 C 838.973694 526.906128 839.130981 273.636841 683.015686 117.331543 Z M 455.850311 653.819031 C 455.850311 659.991028 450.848602 664.988892 444.68042 664.988892 L 355.321472 664.988892 C 349.15332 664.988892 344.151642 659.991028 344.151642 653.819031 L 344.151642 322.097748 C 344.151642 315.925751 349.15332 310.927887 355.321472 310.927887 L 444.68042 310.927887 C 450.848602 310.927887 455.850311 315.923828 455.850311 322.097748 L 455.850311 653.819031 Z M 400.000977 264.571594 C 364.281158 264.571594 335.218811 235.513062 335.218811 199.791382 C 335.218811 164.073486 364.279266 135.009216 400.000977 135.009216 C 435.722656 135.009216 464.783112 164.071594 464.783112 199.791382 C 464.783112 235.513062 435.718811 264.571594 400.000977 264.571594 Z"/>
                      </g>
                      <g id="g1"/>
                    </svg>
                  </a>
        )
      </span>
      <span *ngIf="paylinkSubscription.isSpecialPackage " class="f-8 text-primary">
        ({{ 'Special Package' | translate }})
      </span>
    </h6>
    <div class="row">
      <div class="col-lg-12 mx-auto">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 mt-md-0 mt-4">
            <div class="form">

              <!-- Setup and monthly/yearly feature line -->
              <div class="row my-3" *ngIf="!myBusiness.isPsp">

                <!-- setup fees feature -->
                <div class="col-sm-1 my-2 d-flex">
                  <img alt="setup fees" width="55" height="35" src="./assets/img/setup_fees.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>Setup Fees</span>
                  <span class="my-auto">:</span>
                  <span *ngIf="paylinkSubscription.setupFees > 0" class="my-auto text-primary"> {{ paylinkSubscription.setupFees | number:'1.0-2' }} <span class="my-auto" translate>SAR</span></span>
                  <span *ngIf="paylinkSubscription.setupFees == 0 || !paylinkSubscription.setupFees" class="my-auto text-primary" translate>Free <span *ngIf="oldSetupFees" style="text-decoration: line-through;color:gray">{{ oldSetupFees }} <img height="18" src="assets/sr.svg"></span></span>
                </div>

                <!-- monthly / yearly feature -->
                <div class="col-sm-1 d-flex">
                  <img alt="monthly fees" width="40" height="35" src="./assets/img/monthly-fees.svg" class="my-auto mx-1"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex" *ngIf="!merchantPackage && paylinkSubscription.yearlyFees > 0 && paylinkSubscription.monthlyFees == 0">
                  <div class="my-auto" *ngIf="paylinkSubscription.yearlyFees != 0">
                    <span class="my-auto" translate>Yearly</span>
                    <span class="my-auto">:</span>
                    <span class="my-auto mx-1 text-primary">
                      <span *ngIf="paylinkSubscription.yearlyFees > 0" class="text-primary">
                        {{ paylinkSubscription.yearlyFees | number:'1.0-2' }}
                        <span translate>SAR</span>
                      </span>
                    </span>
                  </div>
                </div>

                <div class="col-sm-5 menu my-2 d-flex" *ngIf="!merchantPackage && ((paylinkSubscription.yearlyFees == 0 && paylinkSubscription.monthlyFees == 0) || paylinkSubscription.monthlyFees > 0)">
                  <span class="my-auto" translate>Monthly Subscription</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 text-primary">
                    <span *ngIf="paylinkSubscription.monthlyFees > 0" class="text-primary">{{ paylinkSubscription.monthlyFees | number:'1.0-2' }}
                      <span translate>SAR</span>
                    </span>
                    <span class="text-primary" *ngIf="!paylinkSubscription.monthlyFees || paylinkSubscription.monthlyFees == 0">
                      {{ 'Free' | translate }}
                    </span>
                  </span>

                  <div class="my-auto" *ngIf="paylinkSubscription.monthlyFees != 0">
                    <span class="my-auto">/</span>
                    <span class="my-auto" translate>Yearly</span>
                    <span class="my-auto">:</span>
                    <span class="my-auto mx-1 text-primary">
                      <span *ngIf="paylinkSubscription.yearlyFees > 0">
                        {{ paylinkSubscription.yearlyFees | number:'1.0-2' }}
                        <span translate>SAR</span>
                      </span>
                    </span>
                  </div>
                </div>

                <!-- current monthly / yearly plan -->
                <div class="col-sm-5 menu my-2 d-flex" *ngIf="merchantPackage">
                  <span class="my-auto" *ngIf="merchantPackage.recurringAmount != 'Yearly'" translate>Monthly Subscription</span>
                  <span class="my-auto" *ngIf="merchantPackage.recurringAmount == 'Yearly'" translate>Yearly Subscription</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 text-primary" *ngIf="merchantPackage.recurringAmount != 'Yearly'">
                    <span *ngIf="paylinkSubscription.monthlyFees > 0">
                      {{ paylinkSubscription.monthlyFees | number:'1.0-2' }}
                      <span translate>SAR</span>
                    </span>
                    <span *ngIf="!paylinkSubscription.monthlyFees || paylinkSubscription.monthlyFees == 0">
                      {{ 'Free' | translate }}
                    </span>
                  </span>
                  <span class="my-auto mx-1 text-primary" *ngIf="merchantPackage.recurringAmount == 'Yearly'">
                    <span *ngIf="paylinkSubscription.yearlyFees > 0">
                      {{ paylinkSubscription.yearlyFees | number:'1.0-2' }}
                      <span translate>SAR</span>
                    </span>
                    <span *ngIf="!paylinkSubscription.yearlyFees || paylinkSubscription.yearlyFees == 0">
                      {{ 'Free' | translate }}
                    </span>
                  </span>
                </div>

              </div>

              <!-- Mada and App rate feature line -->
              <div class="row my-3">
                <div class="col-sm-1 my-2 d-flex">
                  <img alt="mada logo" width="55" src="./assets/img/Mada_Logo.svg" class="my-auto mx-1"/>
                </div>
                <div class="col-sm-5 my-2 d-flex">
                  <span class="my-auto" translate>Mada Rates</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 text-primary">
                    {{ paylinkSubscription.madaRate | number:'1.0-2' }} %
                  </span>
                  <span *ngIf="paylinkSubscription.fixedFees" class="my-auto mx-1 text-primary">
                    + {{ paylinkSubscription.fixedFees }}
                    <span translate>SAR</span>
                  </span>
                </div>
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="40" alt="app fees" height="50" src="./assets/img/app-fees.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>App Usage Rates</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 text-primary" *ngIf="paylinkSubscription.appFeesRate != null && paylinkSubscription.appFeesRate > 0"> {{ paylinkSubscription.appFeesRate }} % {{ 'per transaction' | translate }}</span>
                  <span class="my-auto mx-1 text-primary" *ngIf="paylinkSubscription.appFeesRate == null || paylinkSubscription.appFeesRate == 0">{{ 'Free' | translate }}</span>
                </div>
              </div>

              <!-- Local CC and GCC CC feature line -->
              <div class="row my-3">
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="40" alt="local credit card fees" src="./assets/img/creditcard.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>Local Credit Card Rates</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 text-primary"> {{ paylinkSubscription.localCreditCardRate | number: '1.0-2' }} %</span>
                  <span *ngIf="paylinkSubscription.fixedFees" class="my-auto mx-1">+ {{ paylinkSubscription.fixedFees }}
                    <span translate>SAR</span>
                            </span>
                </div>
                <div class="col-sm-1 menu my-2">
                  <img width="40" alt="gcc credit card fees" src="./assets/img/creditcard.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>GCC Credit Card Rates</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 text-primary"> {{ paylinkSubscription.gccCreditCardRate | number: '1.0-2' }} %</span>
                  <span *ngIf="paylinkSubscription.fixedFees" class="my-auto mx-1">+ {{ paylinkSubscription.fixedFees }}
                    <span translate>SAR</span>
                            </span>
                </div>
              </div>

              <!-- Global CC and Refund feature line -->
              <div class="row my-3">
                <div class="col-sm-1 menu my-2">
                  <img width="40" alt="global credit card fees" src="./assets/img/creditcard.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>International Credit Card Rates</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 text-primary"> {{ paylinkSubscription.globalCreditCardRate | number: '1.0-2' }} %</span>
                  <span *ngIf="paylinkSubscription.fixedFees" class="my-auto mx-1">+ {{ paylinkSubscription.fixedFees }}
                    <span translate>SAR</span>
                            </span>
                </div>
                <div class="col-sm-1 menu my-2">
                  <img width="40" alt="refund fees" src="./assets/img/returns-and-exchanges-green-icon.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto mx-1" translate>Refund Fees</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto text-primary">{{ paylinkSubscription.refundFees | number:'1.0-2' }} <span class="my-auto" translate>SAR</span></span>
                </div>
              </div>

              <!-- Apple Pay and URPay feature line -->
              <div class="row my-3">
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="50" alt="include apple pay" src="./assets/img/apple_pay.svg" class="my-auto mx-1"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>Pay with Apply Pay</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 font-weight-bolder text-success"> {{ 'Available' | translate }}</span>
                </div>
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="50" alt="include ur pay" height="35" src="./assets/img/urpay-logo-only.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>Pay by URPay</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 font-weight-bolder" [ngClass]="paylinkSubscription.includeUrPay? 'text-success' : 'text-danger'">{{ (paylinkSubscription.includeUrPay ? 'Available' : 'Not Available') | translate }}</span>
                </div>
              </div>

              <!-- STC Pay and Tamara feature line -->
              <div class="row my-3">
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="50" alt="include stc pay" src="./assets/img/stcpay.svg" class="my-auto mx-1"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>Pay by STCPay</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 font-weight-bolder" [ngClass]="paylinkSubscription.includeStcPay? 'text-success' : 'text-danger'">{{ (paylinkSubscription.includeStcPay ? 'Available' : 'Not Available') | translate }}</span>
                </div>
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="50" alt="include tamara" height="35" src="./assets/img/tamara.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>Pay by Tamara</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 font-weight-bolder" [ngClass]="paylinkSubscription.includeTamara? 'text-success' : 'text-danger'">{{ (paylinkSubscription.includeTamara ? 'Available' : 'Not Available') | translate }}</span>
                </div>
              </div>

              <!-- AMEX and SADAD feature line -->
              <div class="row my-3">
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="50" alt="include amex" src="./assets/img/amex.svg" class="my-auto mx-1"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>American Express</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 font-weight-bolder" [ngClass]="paylinkSubscription.includeAmex? 'text-success' : 'text-danger'">{{ (paylinkSubscription.includeAmex ? 'Available' : 'Not Available') | translate }}</span>
                </div>
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="50" alt="include sadad" height="35" src="./assets/img/sadad.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>SADAD</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 font-weight-bolder" [ngClass]="paylinkSubscription.includeSadad? 'text-success' : 'text-danger'">{{ (paylinkSubscription.includeSadad ? 'Available' : 'Not Available') | translate }}</span>
                </div>
              </div>

              <!-- API & Paystore feature line -->
              <div class="row my-3">
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="40" alt="include api" height="35" src="./assets/img/api.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>{{ 'Integration with Paylink API' | translate }}</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 font-weight-bolder" [ngClass]="paylinkSubscription.includeApi? 'text-success' : 'text-danger'">{{ (paylinkSubscription.includeApi ? 'Available' : 'Not Available') | translate }}</span>
                </div>
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="50" alt="include shop koshk" height="35" src="./assets/img/shop.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>Having Online Store</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 font-weight-bolder" [ngClass]="paylinkSubscription.includePayStore ? 'text-success' : 'text-danger'">{{ (paylinkSubscription.includePayStore ? 'Available' : 'Not Available') | translate }}</span>
                </div>
              </div>

              <!-- Shopify & Wordpress feature line -->
              <div class="row my-3">
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="40" alt="include shopify" height="35" src="./assets/img/icons8-shopify-150.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>{{ 'Integration with Shopify' | translate }}</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 font-weight-bolder" [ngClass]="paylinkSubscription.includeShopify? 'text-success' : 'text-danger'">{{ (paylinkSubscription.includeShopify ? 'Available' : 'Not Available') | translate }}</span>
                </div>
                <div class="col-sm-1 menu my-2">
                  <img width="50" alt="include wordpress support" height="35" src="./assets/img/wordpress.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>Integrate with Woocommerce</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 font-weight-bolder" [ngClass]="paylinkSubscription.includeApi ? 'text-success' : 'text-danger'"> {{ (paylinkSubscription.includeApi ? 'Available' : 'Not Available') | translate }}</span>
                </div>
              </div>

              <!-- Monthly Limit line for FR-->
              <div class="row my-3" *ngIf="myBusiness.licenseType == 'freelancer' && paylinkSubscription.frMonthlyLimit">
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="40" height="35" src="./assets/img/fence.svg" class="my-auto mx-1 my-auto" alt="monthly limit"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>{{ 'Monthly Limit' | translate }}</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 text-primary">{{ paylinkSubscription.frMonthlyLimit | number:'1.0-2' }} <img height="18" src="assets/sr.svg"></span>
                </div>
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="50" height="35" src="./assets/img/save-money.svg" class="my-auto mx-1 my-auto" alt="additional fees in case exceed limit"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>Additional fees in case the maximum limit is exceeded</span>
                  <span class="my-auto">:</span>
                  <ng-container>
                    <!-- Display 'Not Available' for 'freelancer' or 'cr' license types -->
                    <span class="my-auto mx-1 text-danger"
                          *ngIf="(myBusiness.licenseType === 'freelancer'
                                 && paylinkSubscription.limitExceedCost != null
                                 && paylinkSubscription.frMaxLimit != null
                                 && paylinkSubscription.frMaxLimit === paylinkSubscription.frMonthlyLimit)
                                || (myBusiness.licenseType === 'cr'
                                 && paylinkSubscription.limitExceedCost != null
                                 && paylinkSubscription.crMaxLimit != null
                                 && paylinkSubscription.crMaxLimit === paylinkSubscription.crMonthlyLimit); else checkCost">
                        {{ 'Not Available' | translate }}
                      </span>
                    <!-- Check cost conditions -->
                    <ng-template #checkCost>
                      <span
                        class="my-auto mx-1 text-primary"
                        *ngIf="paylinkSubscription.limitExceedCost != null && paylinkSubscription.limitExceedCost > 0; else free">
                        {{ paylinkSubscription.limitExceedCost | number:'1.0-2' }} <img height="18" src="assets/sr.svg">
                      </span>
                    </ng-template>

                    <!-- Display 'Free' -->
                    <ng-template #free>
                      <span class="my-auto mx-1 text-primary">
                        {{ 'Free' | translate }}
                      </span>
                    </ng-template>
                  </ng-container>
                </div>
              </div>

              <!-- Monthly Limit line for CR-->
              <div class="row my-3 mx-2" *ngIf="myBusiness.licenseType == 'cr' && paylinkSubscription.crMonthlyLimit">
                <div class="col-sm-1 menu my-2">
                  <img width="40" height="35" src="./assets/img/fence.svg" class="my-auto mx-1 my-auto" alt="monthly limit"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>{{ 'Monthly Limit' | translate }}</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 text-primary">{{ paylinkSubscription.crMonthlyLimit | number:'1.0-2' }} <img height="18" src="assets/sr.svg"></span>
                </div>
                <div class="col-sm-1 menu my-2">
                  <img width="40" height="35" src="./assets/img/save-money.svg" class="my-auto mx-1 my-auto" alt="exceed cost"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>Additional fees in case the maximum limit is exceeded</span>
                  <span class="my-auto">:</span>
                  <ng-container>
                    <!-- Display 'Not Available' for 'freelancer' or 'cr' license types -->
                    <span class="my-auto mx-1 text-danger"
                          *ngIf="(myBusiness.licenseType === 'freelancer'
                                 && paylinkSubscription.limitExceedCost != null
                                 && paylinkSubscription.frMaxLimit != null
                                 && paylinkSubscription.frMaxLimit === paylinkSubscription.frMonthlyLimit)
                                || (myBusiness.licenseType === 'cr'
                                 && paylinkSubscription.limitExceedCost != null
                                 && paylinkSubscription.crMaxLimit != null
                                 && paylinkSubscription.crMaxLimit === paylinkSubscription.crMonthlyLimit); else checkCost">
                        {{ 'Not Available' | translate }}
                      </span>
                    <!-- Check cost conditions -->
                    <ng-template #checkCost>
                      <span
                        class="my-auto mx-1 text-primary"
                        *ngIf="paylinkSubscription.limitExceedCost != null && paylinkSubscription.limitExceedCost > 0; else free">
                        {{ paylinkSubscription.limitExceedCost | number:'1.0-2' }} <img height="18" src="assets/sr.svg">
                      </span>
                    </ng-template>

                    <!-- Display 'Free' -->
                    <ng-template #free>
                      <span class="my-auto mx-1 text-primary">
                        {{ 'Free' | translate }}
                      </span>
                    </ng-template>
                  </ng-container>
<!--                  <span class="my-auto mx-1 text-primary" *ngIf="paylinkSubscription.limitExceedCost != null && paylinkSubscription.limitExceedCost > 0">{{ paylinkSubscription.limitExceedCost | number:'1.0-2' }} <img height="18" src="assets/sr.svg"></span>-->
<!--                  <span class="my-auto mx-1 text-primary" *ngIf="paylinkSubscription.limitExceedCost == null || paylinkSubscription.limitExceedCost == 0">{{ 'Free' | translate }}</span>-->
                </div>
              </div>

              <!-- Withdrawal feature line -->
              <div class="row my-3">
                <div class="col-sm-1 menu my-2 d-flex">
                  <img alt="withdraw fees" width="40" height="35" src="./assets/img/withdraw-money.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto">{{ 'Withdraw Fees' | translate }}</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1">
                    <span *ngIf="paylinkSubscription.minimumFreeWithdrawAmount === 0">
                      {{ paylinkSubscription.minimumWithdrawFees | number:'1.0-2' }} <img height="18" src="assets/sr.svg">
                    </span>
                    <span *ngIf="paylinkSubscription.minimumWithdrawFees == 0 && paylinkSubscription.minimumFreeWithdrawAmount == 0">
                      {{ 'Free' | translate }}
                    </span>
                    <span *ngIf="paylinkSubscription.minimumFreeWithdrawAmount == null || !paylinkSubscription.minimumWithdrawFees == null">
                      {{ 'Free' | translate }}
                    </span>
                  </span>
                  <span class="my-auto f-8" translate>
                    <span *ngIf="paylinkSubscription.minimumFreeWithdrawAmount && paylinkSubscription.minimumFreeWithdrawAmount > 0">
                      ({{ paylinkSubscription.minimumWithdrawFees | number:'1.0-2' }} <img height="18" src="assets/sr.svg">)
                    </span>
                  </span>
                </div>
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="40" height="35" src="./assets/img/send.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>Personalize purchase messages with the merchant's name</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 font-weight-bolder" [ngClass]="paylinkSubscription.includeCustomSmsName? 'text-success' : 'text-danger'">{{ (paylinkSubscription.includeCustomSmsName ? 'Available' : 'Not Available') | translate }}</span>
                </div>
              </div>

              <!-- Weekly Transfers -->
              <div class="row my-3">
                <div class="col-sm-1 menu my-2 d-flex">
                  <img width="50" height="35" src="./assets/img/bank-transfer.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>{{ 'Weekly transfers' | translate }}</span>
                  <span class="my-auto">:</span>
                  <span *ngIf="paylinkSubscription.transferInSun" class="my-auto mx-1 text-primary">{{ 'Sun' | translate }}</span>
                  <span *ngIf="paylinkSubscription.transferInMon" class="my-auto mx-1 text-primary">{{ 'Mon' | translate }}</span>
                  <span *ngIf="paylinkSubscription.transferInTue" class="my-auto mx-1 text-primary">{{ 'Tue' | translate }}</span>
                  <span *ngIf="paylinkSubscription.transferInWed" class="my-auto mx-1 text-primary">{{ 'Wed' | translate }}</span>
                  <span *ngIf="paylinkSubscription.transferInThu" class="my-auto mx-1 text-primary">{{ 'Thu' | translate }}</span>
                </div>
                <div class="col-sm-1 menu my-2">
                  <img width="50" height="35" src="./assets/img/money-transfer.svg" class="my-auto mx-1 my-auto"/>
                </div>
                <div class="col-sm-5 menu my-2 d-flex">
                  <span class="my-auto" translate>رسوم التحويل</span>
                  <span class="my-auto">:</span>
                  <span class="my-auto mx-1 text-primary">{{ 'Free' | translate }}</span>
                  <!--                  <span class="my-auto text-primary" style="font-size: 8pt" translate>-->
                  <!--                    <span *ngIf="paylinkSubscription.minimumFreeWithdrawAmount && paylinkSubscription.minimumFreeWithdrawAmount > 0">-->
                  <!--                      ({{ paylinkSubscription.minimumWithdrawFees | number:'1.0-2' }} <img height="18" src="assets/sr.svg"> {{ 'if withdrawal amount equal or less than ' | translate }}-->
                  <!--                      {{ paylinkSubscription.minimumFreeWithdrawAmount | number:'1.0-2' }}<img height="18" src="assets/sr.svg">)-->
                  <!--                    </span>-->
                  <!--                  </span>-->
                </div>
              </div>

              <!-- choosing package button -->
              <div *ngIf="isSelecting">
                <button *ngIf="!submitting && !isCurrentSubscription" class="btn btn-primary" translate (click)="submitPackage()"><span translate>Choose Package</span> {{ paylinkSubscription.subscriptionNameAr }}</button>
                <button *ngIf="!submitting && isCurrentSubscription" class="btn btn-light-dark" translate><span translate>Current Package</span> {{ paylinkSubscription.subscriptionNameAr }}</button>
                <div *ngIf="submitting" class="mx-auto spinner-grow text-info loader-lg"></div>
              </div>

              <!-- Choosing subscription plan -->
              <div *ngIf="isPaying && (paylinkSubscription.monthlyFees != 0 || paylinkSubscription.yearlyFees != 0 )" class="mx-3 my-2">
                <h6 class="p-1 m-1" translate>Choose Subscription Plan</h6>
                <div class="row mx-2">
                  <div class="col-sm-12">
                    <div class="form-check form-check-inline my-2" *ngIf="paylinkSubscription.monthlyFees != 0">
                      <input class="form-check-input" name="paymentPlan" type="radio" [(ngModel)]="paymentPlan" id="monthlyPlan" value="MonthlyPlan">
                      <label class="form-check-label text-primary" for="monthlyPlan">
                        {{ 'Monthly Plan' | translate }} {{ (paylinkSubscription.monthlyFees) * (1 + myBusiness.paylinkVat) | number:'1.0-0' }} <img height="18" src="assets/sr.svg">
                        <span *ngIf="vatAmount > 0" class="text-dark" style="font-size: 8pt">({{ paylinkSubscription.monthlyFees | number:'1.0-2' }} <img height="18" src="assets/sr.svg"> + {{ (paylinkSubscription.monthlyFees * myBusiness.paylinkVat) | number:'1.0-2' }} <img height="18" src="assets/sr.svg"> {{ 'VAT Amount' | translate }})</span>
                      </label>
                    </div>
                    <br/>
                    <div class="form-check form-check-inline my-2" *ngIf="paylinkSubscription.yearlyFees != 0">
                      <input class="form-check-input" name="paymentPlan" type="radio" [(ngModel)]="paymentPlan" id="yearlyPlan" value="YearlyPlan">
                      <label class="form-check-label text-primary" for="yearlyPlan">
                        {{ 'Yearly Plan' | translate }} {{ (paylinkSubscription.yearlyFees) * (1 + myBusiness.paylinkVat) | number:'1.0-0' }} <img height="18" src="assets/sr.svg">
                        <span *ngIf="vatAmount > 0" class="text-dark" style="font-size: 8pt">({{ paylinkSubscription.yearlyFees | number:'1.0-2' }} <img height="18" src="assets/sr.svg"> + {{ (paylinkSubscription.yearlyFees * myBusiness.paylinkVat) | number:'1.0-2' }} <img height="18" src="assets/sr.svg"> {{ 'VAT Amount' | translate }})</span>
                      </label>
                    </div>
                    <br/>
                    <span *ngIf="paylinkSubscription.setupFees > 0 && vatAmount > 0" class="text-dark" style="font-size: 8pt">+ {{ 'Setup Fees' | translate }} ({{ paylinkSubscription.setupFees | number:'1.0-2' }} <img height="18" src="assets/sr.svg"> + {{ (paylinkSubscription.setupFees * myBusiness.paylinkVat) | number:'1.0-2' }} <img height="18" src="assets/sr.svg"> {{ 'VAT Amount' | translate }})</span>
                  </div>
                </div>
              </div>
              <!-- Choosing payment method -->
              <div *ngIf="isPaying && totalAmount != 0" class="mx-3 my-2">
                <h6 class="p-1 m-1" translate>Choose Payment Method</h6>
                <div class="row mx-2">
                  <div class="col-sm-12">
                    <div class="form-check form-check-inline m-2">
                      <input [hidden]="!canPayUsingWallet" class="form-check-input" [ngClass]="canPayUsingWallet? '' : 'strike'" name="paymentVia" type="radio" [(ngModel)]="paymentVia" id="merchantWallet" value="MerchantWallet">
                      <label class="form-check-label text-primary" for="merchantWallet" [ngClass]="canPayUsingWallet? '' : 'strike'">
                        {{ 'Merchant Wallet' | translate }} {{ totalAmountIncludeVat | number:'1.0-2' }} <img height="18" src="assets/sr.svg">
                        <span class="f-8 text-dark">({{ 'Current Balance' | translate }} {{ wallet | number:'1.0-2' }} <img height="18" src="assets/sr.svg">)</span>
                      </label>
                    </div>
                    <br/>
                    <div class="form-check form-check-inline m-2">
                      <input class="form-check-input" name="paymentVia" type="radio" [(ngModel)]="paymentVia" id="bankCard" value="BankCard">
                      <label class="form-check-label text-primary" for="bankCard">
                        {{ 'Bank Card' | translate }} {{ totalAmountIncludeVat | number:'1.0-2' }} <img height="18" src="assets/sr.svg">
                      </label>
                    </div>
                  </div>
                </div>

                <div class="p-1 my-5 mx-1" translate>
                  <div class="row my-2">
                    <div class="col-3">{{ 'Order Amount' | translate }}</div>
                    <div class="col-9">{{ this.totalAmount | number:'1.2-2' }} <img height="18" src="assets/sr.svg"></div>
                  </div>
                  <div class="row my-2">
                    <div class="col-3">{{ 'VAT Amount' | translate }} <span style="font-size: 8pt">({{ myBusiness.paylinkVat * 100 | number:'1.0-2' }}%)</span></div>
                    <div class="col-9">{{ this.vatAmount | number:'1.2-2' }} <img height="18" src="assets/sr.svg"></div>
                  </div>
                  <div class="d-flex flex-row my-5">
                    <div class=""><h3>{{ 'Total' | translate }}:</h3></div>
                    <div class=""><h3>{{ this.totalAmountIncludeVat | number:'1.2-2' }} <img height="32" src="assets/srb.svg"></h3></div>
                  </div>
                </div>

                <div class="form-check mt-5 mx-3" *ngIf="isPaying">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="approveTerms" name="approveTerms" id="approveTerms1">
                  <label class="form-check-label text-danger-80" for="approveTerms1">
                    لا يمكن استرجاع قيمة الإشتراك بعد دفع قيمته، <span class="font-weight-bolder text-danger">و أوافق على ذلك.</span> للمزيد نرجو الإطلاع على <a class="text-primary" target="_blank" href="https://paylink.sa/terms">الشروط والأحكام</a>.
                  </label>
                </div>

                <!-- Pay button -->
                <div class="row mx-2 my-5">
                  <div class="col-sm-12">
                    <button *ngIf="!submitting" class="btn btn-primary" translate (click)="submitPayment()">
                      <span *ngIf="!isRenew" translate>Pay & Change Package</span>
                      <span *ngIf="isRenew" translate>Pay & Renew Package</span>
                    </button>
                    <div *ngIf="submitting" class="mx-auto spinner-grow text-info loader-lg"></div>
                  </div>
                </div>
              </div>

              <!-- Change Package button -->
              <div *ngIf="isPaying && totalAmount == 0" class="mx-3 my-2">

                <div class="form-check mt-5 mx-3" *ngIf="isPaying && paylinkSubscription.subscriptionType != 'marketing'">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="approveTerms" name="approveTerms" id="approveTerms">
                  <label class="form-check-label text-danger-80" for="approveTerms">
                    لا يمكن استرجاع قيمة الإشتراك بعد دفع قيمته، <span class="font-weight-bolder text-danger">و أوافق على ذلك.</span> للمزيد نرجو الإطلاع على <a class="text-primary" target="_blank" href="https://paylink.sa/terms">الشروط والأحكام</a>.
                  </label>
                </div>

                <div class="row mx-2 my-5">
                  <div class="col-sm-12">
                    <button *ngIf="!submitting" class="btn btn-primary" translate (click)="submitPayment()"><span translate>Change Package</span></button>
                    <div *ngIf="submitting" class="mx-auto spinner-grow text-info loader-lg"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
